module.exports = __webpack_public_path__ + "img/eematico-toys-jucarii-pachet-discovery.31067545.jpg";